import { createFileRoute } from '@tanstack/react-router'

import { HEAT_PUMP_CHILLER_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { technicalRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Vue technique de la PAC / groupe froid. Gardes, search et préchargements sont communs aux
// catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/heat-pump/technical/')(technicalRouteOptions(HEAT_PUMP_CHILLER_DOMAIN))
